module.exports = __webpack_public_path__ + "static/media/cup.bfb43b47.svg";